export const getLimitedText = (text: string, length = 250) => {
	const longValid = text?.split('').length >= length;
	if(longValid) {
		return text.split('').splice(0, length).join('').concat("...");
	} else return text;
}